import { MenuItem, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelectedPaymentConfiguration } from "../../../state/selectedPaymentConfiguration";
import { typography } from "../../../utils/typography";

/**
 * Switches which registered company the payments account screens are showing.
 *
 * Only companies that are ready to use are listed — one still going through
 * registration has no history to look at. Rendered only when there is something
 * to switch between: with a single company it is already named in the page
 * title, and with none there is nothing to select yet.
 */
export default function CompanySelector() {
  const { t } = useTranslation();
  const {
    selectableConfigurations,
    configId,
    setConfigId
  } = useSelectedPaymentConfiguration();

  if (selectableConfigurations.length < 2) return null;

  return (
    <TextField
      select
      size="small"
      label={t("paymentsAccount.company")}
      value={configId ?? ""}
      onChange={event => setConfigId(event.target.value)}
      sx={{
        minWidth: { xs: "100%", sm: "260px" },
        "& .MuiInputBase-input": { ...typography.body.m }
      }}
    >
      {selectableConfigurations.map(configuration => (
        <MenuItem key={configuration.id} value={configuration.id}>
          {configuration.organizationName}
        </MenuItem>
      ))}
    </TextField>
  );
}
